import React, {Fragment} from 'react';
import Avatar from "UI/Avatar";
import Dropdown from 'UI/Dropdown';
import Logout from "Components/Logout/Logout";

import { Menu } from "@headlessui/react";
import classNames from "classnames";

const initials = name => {
    const initials = name.match(/\b\w/g) || [];
    return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
};

const ProfileButton = ({user, triggerRef}) => {

    const classes = classNames({
        "w-full items-center text-gray-400 hover:text-gray-600 focus:bg-indigo-600 hover:bg-indigo-600 focus:outline-none": true,
    });

    return <Dropdown.Button ref={triggerRef} className={classes}>
        <span className="sr-only">Open options</span>
        <div className="flex-shrink-0 flex border-t border-indigo-800">
            <div className="flex-shrink-0 w-full block p-4">
                <div className="flex items-center">
                    <div className='flex-shrink-0'>
                        <Avatar
                            className='bg-indigo-500'
                            initials={initials(user.name)}
                            circular
                            size='sm'
                        />
                    </div>
                    <div className="ml-3 text-left truncate flex-grow hidden md:block">
                        <p className="text-sm font-medium text-white overflow-hidden overflow-ellipsis">{user.name}</p>
                        <p className="text-xs font-medium text-indigo-200  overflow-hidden overflow-ellipsis">
                            {user.email}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </Dropdown.Button>;
}

export default function Profile({user}) {
    const profileButton = ({triggerRef}) => <ProfileButton user={user} triggerRef={triggerRef} />;

    return <Dropdown button={profileButton} origin='bl'>
        <Dropdown.LinkItem to="/user">
            User settings
        </Dropdown.LinkItem>
        <Logout />
    </Dropdown>;
}
